import { defaultTrashFilterDocument } from '@griply/utils';
import React, { useRef } from 'react';
import { VirtualizedTreeListProvider } from 'shared/components/ui/virtualized-tree-list';
import { ProvidedTaskFilterList } from 'shared/views/task-filter-list';

import { PageTopBar } from './components/page-top-bar';
import * as Styled from './trash.style';

const noOrder = {};

export const Trash: React.FC = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  return (
    <Styled.Container>
      <Styled.Main>
        <VirtualizedTreeListProvider>
          <Styled.MainContent>
            <PageTopBar />
            <Styled.Content ref={scrollRef}>
              <ProvidedTaskFilterList
                scrollElement={scrollRef}
                filterDocument={defaultTrashFilterDocument}
                defaultFilterDocument={defaultTrashFilterDocument}
                customOrder={noOrder}
                includeArchived
              />
            </Styled.Content>
          </Styled.MainContent>
        </VirtualizedTreeListProvider>
      </Styled.Main>
    </Styled.Container>
  );
};
